$(function () {
	let $popup = $('.js-popup');
	let $popupCloseBtn = $('.js-popup-close');
	let lastOpenedPopup = null;
	let scrollPosition;
	const closePopup = new CustomEvent('closePopup', {});

	let isPopupOpened = false

	$('body').on('click','.js-popup-link',function(e){
		e.preventDefault();

		isPopupOpened = true
		let $this = $(this);
		let target = $this.attr('data-link');
		let href = $this.attr('data-href');
		let url = $this.attr('href')
		let videoSrc = $this.attr('data-src');
		let method = $this.attr( 'data-method' );
		let action = $this.attr( 'data-action' );
		let ids = $this.attr( 'data-ids' );
		let modal = $this.attr( 'data-open' );
		if(ids && ids.length) ids = ids.split(',')

		openPopup(target, href, modal, videoSrc, url, method, action, ids);


		if (typeof $this.data('scrollto') !== 'undefined' ) {
			setTimeout(function () {
				let form = $('.js-ajax-wrapper').find('form');
				if (form.length) {
					form.find('input:not([type="hidden"])').first().focus();
				}
			}, 1500);
		}

		return false;
	});



	function openPopup(target, href, modal, videoSrc = null, url = null, method = null, action = null, ids = null) {
		const $elem = $('.js-popup[data-block="'+target+'"]');
		

		scrollPosition = $(window).scrollTop();

		if(!!videoSrc) {
			let video = $elem.find('.js-iframe');
			video.attr('src',videoSrc);
		}

		scrollPosition = $(window).scrollTop();

		if (href) {
			history.pushState({}, '', url ? url : href);
			if (modal) {
				$('.js-map-modal').addClass('is-show');
				$('.js-map-modal').find('.js-ajax-wrapper').empty();
				getEventItem(href, $('.js-map-modal'));
			} else {
				$popup.removeClass('is-show');
				$elem.addClass('is-show');
				$('.js-popup[data-block="'+target+'"]').find('.js-ajax-wrapper').empty();
				getEventItem(href,$('.js-popup[data-block="'+target+'"]'));
			}
			lastOpenedPopup = 'href';
		} else {
			$popup.removeClass('is-show');
			$elem.addClass('is-show');
		}
	}

	window.openPopup = openPopup;

	$popupCloseBtn.on('click',function(){
		isPopupOpened = false
		let $this = $(this);
		let $popup = $this.closest('.js-popup');

		$popup.removeClass('is-show');
		$popup.find('.js-iframe').attr('src','');
		// location.hash = '';
		if (scrollPosition !== "undefined") {
			$(window).scrollTop(scrollPosition);
			scrollPosition = undefined;
		}

		if (lastOpenedPopup === 'href') {
			// history.pushState({}, '', window.location.pathname);
			history.back();
			let scrollPositionLast = $(window).scrollTop();
			// setTimeout(function(){
			// 	location.hash = ' '
			// }, 500);
			lastOpenedPopup = null;
		}

		document.dispatchEvent(closePopup);
	});

	function getEventItem(item,elem) {
		$.ajax({
			url: item,
			type: "GET",
			success: function(data) {
				if ($(data).length !== 0) {

					elem.find('.js-ajax-wrapper').html($(data).hide().fadeIn(1000));
					if($(data).find('.seo-title').length) {
						$('title').html($(data).find('.seo-title').val())
					}

					if($(data).find('.seo-description').length) {
						$('meta[name="description"]').attr('content', $(data).find('.seo-description').val())
					}

					setTimeout(function () {
						//lazyloadImages();
						formValidate();
						initSelect();
						initSelectLabel();
						// inputMask();
						// initSelectInput();
						// initSelectSearch();
					}, 1000);

				}
			}
		});
	}

});
